import PrescriptionBaseModel from '@/models/prescription-base-model';
import IPrescriptionTemplate, {
  TypePrescricaoTemplate,
} from '@/interfaces/prescription-template';
import { TypePatient } from '@/interfaces/patient';
import { IUnitClient } from '@/interfaces/client';
import { IPadraoTemplate } from '@/interfaces/padroes-template';
import { IParameterValue } from '@/interfaces/parameters';
import { PROFILE, PATTERN } from '@/settings/consts/template-types';
import { toUpperCase } from '@/helpers/toUpperCase';
import { IdNomeDTO, IdNumNomeDTO } from '@/interfaces/base-dto';

export default class PrescriptionTemplateModel extends PrescriptionBaseModel {
  public nome: string;
  public codigo: string;
  public tipoPrescricao: TypePrescricaoTemplate;
  public tipoPaciente: TypePatient;
  public termo: string;
  public paciente: any = {};
  public peso: string;
  public ativo: boolean;
  public modelosBolsasMulti: IdNumNomeDTO[];

  constructor(_initialValue?: IPrescriptionTemplate) {
    super(_initialValue);

    const initialValue = _initialValue || {
      codigo: null,
      nome: null,
      tipoPrescricao: PATTERN,
      // unidade: null,
      peso: null,
      tipoPaciente: null,
      divisaoBolsas: 1,
      termo: null,
      produtos: [],
      ativo: true,
      unidadesCliente: [],
      padroesTemplate: [],
      modelosBolsasMulti: []
    };

    this.paciente = {
      tipo: initialValue.tipoPaciente,
      termo: initialValue.termo,
      peso: initialValue.peso,
    };

    this.tipoPrescricao = initialValue.tipoPrescricao;
    this.codigo = initialValue.codigo;
    this.nome = initialValue.nome;
    this.peso = initialValue.peso;
    this.tipoPaciente = initialValue.tipoPaciente;
    //this.unidade = initialValue.unidade;
    this.termo = initialValue.termo;
    this.divisaoBolsas = 1;
    this.setProducts(this.formatTemplateProducts(initialValue.produtos));
    this.ativo = initialValue.ativo;
    this.setClientesTemplates(initialValue.unidadesCliente);
    this.setPadroesTemplates(initialValue.padroesTemplate);
    this.modelosBolsasMulti = initialValue.modelosBolsasMulti;
  }

  public formatTemplateProducts(products: any[]): any[] {
    const newProducts = products.map((item) => {
      item.unidadeMedidasProduto.valor = item.quantidade;
      return {
        ...item.produto,
        idProduto: item.produto.id,
        unidades: [item.unidadeMedidasProduto],
      };
    });

    return newProducts;
  }

  // @Override
  public valid(): boolean {
    return (
      !!this.nome &&
      !!this.codigo &&
      !!this.tipoPaciente &&
      !!this.produtos.length
    );
  }

  // @Override
  public toJson(): any {
    return {
      ...super.toJson(),
      paciente: {        
        peso: this.paciente.peso,
        tipo: this.tipoPaciente,
        termo: this.termo,
      },
      id: this.id,
      ativo: this.ativo,
      codigo: toUpperCase(this.codigo),
      nome: toUpperCase(this.nome),
      tipoPrescricao: this.tipoPrescricao,
      tipoPaciente: this.tipoPaciente,
      //unidade: this.unidade,
      termo: this.termo,
      //peso: this.peso,
      //tempoInfusao: this.tempoInfusao,
      produtos: this.changeProductsStructure(this.produtos),
      unidadesCliente: this.unidadesCliente ? this.unidadesCliente.map(u => { return {id: u.id} }) : [],
      padroesTemplate: this.changePadroesStructure(this.padroesTemplate),
    };
  }

  private changeProductsStructure(products): any[] {
    const newProducts = products.map((product) => {
      if (!product.unidadeMedidasProduto) {
        return product;
      }

      return {
        produto: {
          id: product.id,
          descricao: product.descricao,
        },
        quantidade: product.unidadeMedidasProduto[0].valor,
        unidadeMedidasProduto: product.unidadeMedidasProduto[0],
      };
    });

    return newProducts;
  }


  private changePadroesStructure(padroes): any[] {
    if(!padroes)
      return null;

    const newPadrao = padroes.map((padrao) => {
      // if(padrao.parametro)
      //   padrao.valor.parametro = padrao.parametro;
      return  padrao;
    });

    return newPadrao;
  }

}
